import { Injectable } from '@angular/core';
import { ConsentLinksMapper } from '../mappers/consent-links.mapper';
import { ConsentUrlAdaptingParams } from '../models/consent-urls-adapting.params';
import { ConsentUrlsAdapted } from '../models/consent-urls-adapted.model';

@Injectable({
  providedIn: 'root',
})
export class ConsentLinksAdapter {
  adapt(
    consentUrlAdaptingParams: ConsentUrlAdaptingParams,
    isSecondPlatformPage: boolean,
  ): ConsentUrlsAdapted {
    const { consents, userRole, identType } = consentUrlAdaptingParams;
    const roleOrIdentType = userRole ?? identType;

    const secondPlatformLinks = {
      ...ConsentLinksMapper.mapSecondPlatformConsentLinks(consents),
      ...ConsentLinksMapper.mapAdditionalConsentLinks(consents),
    };

    if (roleOrIdentType) {
      return {
        ...ConsentLinksMapper.consentLinksByRoleOrIdentType(consents)[
          roleOrIdentType
        ],
        ...ConsentLinksMapper.mapAdditionalConsentLinks(consents),
      };
    }

    if (isSecondPlatformPage) {
      return secondPlatformLinks;
    }

    return secondPlatformLinks;
  }
}
